import { useState } from 'react';
import { FloatingLabel, Form } from 'react-bootstrap'
import { CandidateValidationError } from '@/models/file-submission.tsx'
import Table from '@/components/shared/tables/Table'
import { ColumnDef } from '@tanstack/react-table'
import Icon from '@/components/shared/Icon.tsx'
import { ColumnFiltersState, OnChangeFn } from '@tanstack/react-table'

const columns: ColumnDef<CandidateValidationError<string>, any>[] = [
    {
        id: 'ErrorRecordId',
        accessorKey: 'ErrorRecordId',
        header: "Row #",
        size: 6, 
    },
    {
        id: 'CSPPID',
        accessorKey: 'CSPPID',
        header: "CSPPID",
        size: 8,
    },
    {
        id: 'Fieldname',
        accessorKey: 'Fieldname',
        header: "Field Name",
        size: 10,
    },
    {
        id: 'Code',
        accessorKey: 'Code',
        header: "Error Code",
        size: 14,
        meta: {
          filterVariant: 'select',
        },
    },
    {
        id: 'Message',
        accessorKey: 'Message',
        header: "Error Message",
    },
]

export default function ErrorsSection({ 
    errors,
    columnFilters,
    onColumnFiltersChange
}: { 
    errors: CandidateValidationError<string>[]
    columnFilters: ColumnFiltersState;
    onColumnFiltersChange: OnChangeFn<ColumnFiltersState>; 
}) {
    // const [showFilters, setShowFilters] = useState(false);

    // const handleFilterToggleClick = () => { 
    //     if (showFilters) {
    //         setShowFilters(false)
    //     } else {
    //         setShowFilters(true)
    //     } 
    // };

    return (
        <div className="h-100 border p-3">
            <div className="d-flex align-items-center justify-content-between">
                <div className="mb-2 flex-grow-1">Errors</div>
                {/* { errorCodes.length > 1 && 
                    <button 
                        className="btn btn-icon fs-5"
                        onClick={handleFilterToggleClick}
                    >
                        <Icon name="filter" />
                    </button>
                } */}
            </div>
            {/* { showFilters && 
                <div>
                    <div className="mb-3">
                        <label className="d-flex align-items-center mb-0">
                            <span className="d-block me-2">Error Code</span>
                            <Form.Select aria-label="Default select example">
                                <option value="">Select one</option>
                                { errorCodes.map((code) => 
                                    <option key={code} value={code}>{code}</option>
                                )}
                            </Form.Select>
                        </label>
                    </div>
                </div>
            } */}
            <Table
                data={errors}
                columns={columns}
                columnFilters={columnFilters}
                onColumnFiltersChange={onColumnFiltersChange}
                initialPageSize={200}
                maxHeight={300}
            />
        </div>
    )
}